import React from 'react'
import styled from '@emotion/styled'
import { breakpoints } from '../../../constants'
import { goldLight10, grayLight20, grayLight40, fontSize4XSmall, grayBase } from '../../../constants/principles'
import { useStateValue } from '../../../hooks'
import { BrowserUtils } from '../../../utils/siteUtils'
import { RadioButton } from '../button'
import { ButtonGroup } from '../buttonGroup'
import Triangle from '../ExclamationTriangle'
import { useGlobalState } from '../../../hooks/GlobalStateProvider'

export default ({
  pills = [],
  onClickItem,
  selectedIndex,
  uniformSize = true,
  isSystemChange,
  onClickSystemChange,
  isDisabled,
  locked,
  id,
  isError,
  fullWidth,
  shouldShowCheck = false,
  stackedVertically = false,
  showIsDefault = false,
  subTextOverride = null,
  testId,
}) => {
  const [isActive, toggleActive] = useStateValue(pills.map(() => false))
  // When pills with long text are too wide to fit in modal window, reduce padding.
  const narrow = !BrowserUtils.isDesktop() && pills.join('').length > breakpoints.pill
  const { globalState } = useGlobalState()

  return (
    <ButtonDiv fullWidth={fullWidth}>
      {isSystemChange && (
        <TriangleSpan onClick={onClickSystemChange}>
          <TriangleDiv>
            <Triangle colorFill={goldLight10} width="14px" height="14px" />
          </TriangleDiv>
        </TriangleSpan>
      )}
      <ButtonGroup column={stackedVertically}>
        {pills.map((child, index) => {
          const value = child && (child.displayName || child)
          const isSelectedBoolean = selectedIndex === index
          let subText = showIsDefault && child.isDefault ? '(Most Common)' : null
          if (subText === null && subTextOverride != null) {
            subText = subTextOverride
          }

          return (
            <StyledButton
              onClick={() => !isDisabled && !locked && !globalState.isFetchingChanges && onClickItem(index, !isSelectedBoolean)}
              width={stackedVertically ? 100 : 100 / pills.length} // full width when vertically stacked
              id={`${id || value}-${index}`}
              data-testid={`${testId?.toString().replace(/[^A-Z0-9]/ig, "-").toLowerCase()}-${value?.toString().replace(/[^A-Z0-9]/ig, "-").toLowerCase()}`}
              uniformSize={uniformSize}
              isSelected={isSelectedBoolean}
              key={index}
              disabled={isDisabled}
              isError={isError}
              isCheck={pills.length === 1 || shouldShowCheck}
              narrow={narrow}
              stackedVertically={stackedVertically}
              onMouseDown={() => {
                toggleActive(
                  isActive
                    .slice(0, index)
                    .concat([true])
                    .concat(isActive.slice(index + 1))
                )
              }}
              onMouseOver={() => {
                toggleActive([false, false])
              }}
              onMouseUp={() => toggleActive([false, false])}
              onMouseOut={() => {
                toggleActive([false, false])
              }}>
              {(pills.length === 1 || shouldShowCheck) && !isDisabled && <StyledImg isSelected={isSelectedBoolean} alt="check" src={__PATH_PREFIX__ + (locked ? '/lock.svg' : '/checkmark.svg')} />}
              <StyledText isSelected={isSelectedBoolean} shift={pills.length === 1 || shouldShowCheck}>
                {value}
                {subText && <MostCommonDiv isSelected={isSelectedBoolean || isActive[index]}>{subText}</MostCommonDiv>}
              </StyledText>
            </StyledButton>
          )
        })}
      </ButtonGroup>
    </ButtonDiv>
  )
}

const ButtonDiv = styled.div`
  width: ${p => (p.fullWidth ? '100%' : '')};
  position: relative;
`
const StyledButton = styled(RadioButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  ${p =>
    p.uniformSize &&
    `width: ${p.width}%;
   min-width: 75px;`}
  ${p => p.stackedVertically && `min-width: 300px;`}
  &:disabled {
    border-color: ${grayLight40};
    background: ${grayLight40};
    color: ${grayLight20};
    cursor: not-allowed;
  }
`
const StyledImg = styled.img`
  width: 16px;
  height: 16px;
  ${p => !p.isSelected && `display:none;`}
`
const StyledText = styled.div`
  padding-left: ${p => (p.isSelected && p.shift ? `6px` : `0px`)};
`
const TriangleDiv = styled.div`
  padding: 0px 5px;
`
const TriangleSpan = styled.span`
  position: absolute;
  top: 0px;
  right: 0px;
  background-color: white;
  border: 1px solid ${goldLight10};
  border-radius: 50%;
`
const MostCommonDiv = styled.div`
  font-size: ${fontSize4XSmall};
  color: ${p => (p.isSelected ? `white` : grayBase)};
`
